import { useEffect } from "react"
import { Notifications } from "@orbital/games-frontend-library"
export const useErrorHandlers = (
  err: string,
  btn: any,
  click: any,
  row: any,
) => {
  useEffect(() => {
    switch (err) {
      case Notifications.invalidBet:
      case Notifications.notEnoughBalance:
      case Notifications.invalidAction:
      case Notifications.notFound:
      case Notifications.maxbetlimit:
        click(false)
        row(true)
        setTimeout(() => {
          click(true)
          row(false)
          setTimeout(() => {
            btn("")
          }, 333)
        }, 1168)
        break
      default:
        break
    }
  }, [err, btn, click, row])

  return
}
